import { render, staticRenderFns } from "./CourseBasicProgressItem.vue?vue&type=template&id=6ff2ad1a&scoped=true"
import script from "./CourseBasicProgressItem.vue?vue&type=script&lang=js"
export * from "./CourseBasicProgressItem.vue?vue&type=script&lang=js"
import style0 from "./CourseBasicProgressItem.vue?vue&type=style&index=0&id=6ff2ad1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff2ad1a",
  null
  
)

export default component.exports